import { enumTagType, TagType } from '@rematter/frontend-lib-api-client';
import { Badge } from '@rematter/ui-web';

import { useTranslations } from '../../i18n/useTranslations';

type TagTypeBadgeProps = {
  tagType: TagType;
};

const TYPE_BADGE_COLOR: Record<TagType, 'warning' | 'success'> = {
  [enumTagType.WorkInProgress]: 'warning',
  [enumTagType.FinishedGood]: 'success',
};

export const TagTypeBadge = ({ tagType }: TagTypeBadgeProps) => {
  const t = useTranslations();

  return (
    <Badge color={TYPE_BADGE_COLOR[tagType]} className="@TagTypeBadge">
      {t.tagsListView.tagTypes[tagType]}
    </Badge>
  );
};
